import React, { InputHTMLAttributes, PropsWithChildren } from "react";

export type TypeLabelWrapper = {
  label?: string;
  alignment?: "vertical" | "horizontal";
} & Pick<
  InputHTMLAttributes<HTMLInputElement>,
  "required" | "disabled" | "className"
>;

const LabelWrapper = ({
  label,
  required = false,
  children,
  className = "xl:w-30p",
  alignment = "vertical",
}: PropsWithChildren<TypeLabelWrapper>) => {
  return (
    <div
      className={`w-full ${
        alignment === "vertical" ? "space-y-8" : "flex space-x-8 items-center"
      }  ${className}`}
    >
      {!!label && (
        <p className="text-12 text-neutral-black font-700">
          {label}
          {required && <sup>*</sup>}
        </p>
      )}
      {children}
    </div>
  );
};

export default LabelWrapper;
